import { onReady } from '../../shared/utils/helpers';
import Base from '../../components/base/base';
import CookieConsent from '../../components/cookie-consent/cookie-consent';
import Header from '../../components/header/header';
import BuyerIntakeForm from '../../components/buyer-intake-form/buyer-intake-form';
import './contact.scss';

interface ContactPageOptions {
  debug?: boolean;
  [key: string]: any;
}

class ContactPage extends Base {
  private header: Header;

  constructor(options: ContactPageOptions = {}) {
    // Pass debug option to Base class
    super(options.debug || false);
    this.debug = options.debug || false;
    
    // Initialize header with same debug setting for consistent logging
    this.header = new Header({ debug: this.debug });
    this.init();
  }

  init(): void {
    this.log('ContactPage initialized');

    // Cookie consent gate. Webflow holds the Meta Pixel until this grants.
    try {
      new CookieConsent({ debug: this.debug });
      this.log('CookieConsent initialized');
    } catch (e) {
      this.log('CookieConsent init failed or skipped', e);
    }

    // Initialize Buyer Intake Form
    try {
      new BuyerIntakeForm({ debug: this.debug });
      this.log('BuyerIntakeForm initialized');
    } catch (e) {
      this.log('BuyerIntakeForm init failed or skipped', e);
    }
  }
}

onReady(() => {
  // You can enable debug mode by passing { debug: true }
  new ContactPage({ debug: true });
});

export default ContactPage;